import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const EVVChangeReasonsPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'reason', label: 'Reason' },
    { key: 'category', label: 'Category' },
    { key: 'requiresApproval', label: 'Requires Approval' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'reason', label: 'Reason', type: 'text', required: true },
    { key: 'category', label: 'Category', type: 'select', required: true, options: [
      { value: 'Clock In/Out', label: 'Clock In/Out' },
      { value: 'Location', label: 'Location' },
      { value: 'Schedule', label: 'Schedule' },
      { value: 'System', label: 'System' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'requiresApproval', label: 'Requires Approval', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]},
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'FORGOT', reason: 'Forgot to Clock In/Out', category: 'Clock In/Out', requiresApproval: 'Yes', active: 'Yes' },
    { id: '2', code: 'TECH', reason: 'Technology/Device Issue', category: 'System', requiresApproval: 'No', active: 'Yes' },
    { id: '3', code: 'SIGNAL', reason: 'No GPS Signal', category: 'Location', requiresApproval: 'No', active: 'Yes' },
    { id: '4', code: 'EARLY', reason: 'Early Arrival', category: 'Schedule', requiresApproval: 'Yes', active: 'Yes' },
    { id: '5', code: 'LATE', reason: 'Late Arrival', category: 'Schedule', requiresApproval: 'Yes', active: 'Yes' },
    { id: '6', code: 'EXTEND', reason: 'Extended Visit', category: 'Schedule', requiresApproval: 'Yes', active: 'Yes' },
    { id: '7', code: 'LOCCHG', reason: 'Location Change', category: 'Location', requiresApproval: 'Yes', active: 'Yes' },
    { id: '8', code: 'OTHER', reason: 'Other (See Notes)', category: 'Other', requiresApproval: 'Yes', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="EVV Change Reasons"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Reason"
      formFields={formFields}
      apiEndpoint="/setup/evv-change-reasons"
    />
  );
};

export default EVVChangeReasonsPage;
